import React, { useContext, useEffect } from 'react'
import { createPortal } from 'react-dom'
import PropTypes from 'prop-types'

export const getBodyElement = () => document.body
export const PortalContext = React.createContext(getBodyElement())

export const Portal = ({ children }) => {
  const rootNode = useContext(PortalContext)

  const [hostNode] = React.useState(() => {
    const el = document.createElement('div')
    el.className = Portal.__className
    return el
  })

  useEffect(() => {
    if (!hostNode || !rootNode) {
      return
    }
    rootNode.appendChild(hostNode)
    return () => {
      rootNode.removeChild(hostNode)
    }
  }, [hostNode, rootNode])

  if (!hostNode) {
    return null
  }

  return createPortal(
    <PortalContext.Provider value={hostNode}>
      {children}
    </PortalContext.Provider>,
    hostNode
  )
}

Portal.__className = '__maui-portal'
Portal.__selector = `__${Portal.__className}`

Portal.propTypes = {
  children: PropTypes.node.isRequired,
}
